import { Domain, IPublicSettings, IStateController, Page, Website, IPage } from "../interfaces/Interfaces"
import { Overlay } from "interfaces/InterfacesEntities"

export enum LoadingState {
  idle = 'idle',
  loading = 'loading',
  offline = 'offline',
  reload = 'reload'
}

export default class implements IStateController {
  pages: {
    [type: string]: {
      [key: string]: IPage
    }
  }
  currentPage?: {
    type: string,
    id: string
  }
  websiteSettings: Website
  domain: Domain
  cookies: { cookie_consent_dismissed: boolean }
  editMode: boolean
  publicConfig: IPublicSettings
  loadingState: LoadingState
  overlay: Overlay

  constructor() {
    this.pages = {}
    this.websiteSettings = null
    this.publicConfig = null
    this.domain = null
    this.cookies = {
      cookie_consent_dismissed: false
    }
    this.editMode = false
    this.loadingState = LoadingState.idle
  }
}
